import {
  currencySortComparator,
  flatSortComparator,
  percentageSortComparator,
} from "../../../helpers/campainRowFormatHelpers";

export const metricsColumns = [
  {
    field: "impressions",
    headerName: "Impressions",
    width: 170,
    sortComparator: flatSortComparator,
    type: "FLAT",
    sortable: true,
  },
  {
    field: "clicks",
    headerName: "Clicks",
    width: 150,
    sortComparator: flatSortComparator,
    type: "FLAT",
    sortable: true,
  },
  {
    field: "conversions",
    headerName: "Conversions",
    width: 160,
    sortComparator: flatSortComparator,
    type: "FLAT",
    sortable: true,
  },
  {
    field: "spend",
    headerName: "Spent (USD)",
    width: 160,
    sortComparator: currencySortComparator,
    type: "CURRENCY",
    sortable: true,
  },
  {
    field: "segment_count_nam",
    headerName: "Segment Count NAM",
    width: 230,
    sortComparator: flatSortComparator,
    type: "FLAT",
    sortable: true,
  },
  {
    field: "cpc_usd",
    headerName: "CPC (USD)",
    width: 150,
    sortComparator: currencySortComparator,
    type: "CURRENCY",
    hide: true,
    sortable: true,
  },
  {
    field: "cpm_usd",
    headerName: "CPM (USD)",
    width: 150,
    sortComparator: currencySortComparator,
    type: "CURRENCY",
    hide: true,
    sortable: true,
  },
  {
    field: "ctr",
    headerName: "CTR",
    width: 120,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "click_through_conversions",
    headerName: "Clickthrough Conversions",
    width: 260,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "average_viewable_seconds",
    headerName: "Average Viewable Seconds",
    width: 260,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "conversion_orders",
    headerName: "Conversion Orders",
    width: 200,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "conversions_value",
    headerName: "Conversions Value",
    width: 200,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "invalid_impression_percent",
    headerName: "Invalid Impression %",
    width: 230,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "invalid_impressions",
    headerName: "Invalid Impressions",
    width: 200,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "measurable_impression_percent",
    headerName: "Measurable Impression %",
    width: 240,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "measurable_impressions",
    headerName: "Measurable Impressions",
    width: 230,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "measurable_invalid_impressions",
    headerName: "Measurable Invalid Impressions",
    width: 280,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "postback_conversions",
    headerName: "Postback Conversions",
    width: 220,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "spend_per_conversion",
    headerName: "Spent Per Conversion",
    width: 220,
    sortComparator: currencySortComparator,
    type: "CURRENCY",
    hide: true,
    sortable: true,
  },
  {
    field: "video_companion_ctr",
    headerName: "Video Companion CTR",
    width: 230,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "video_companion_clicks",
    headerName: "Video Companion Clicks",
    width: 240,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "video_companion_views",
    headerName: "Video Companion Views",
    width: 240,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "video_complete_percent",
    headerName: "Video Complete Percent",
    width: 240,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "video_completes",
    headerName: "Video Completes",
    width: 190,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "video_midpoints",
    headerName: "Video Midpoints",
    width: 180,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "video_plays",
    headerName: "Video Plays",
    width: 150,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "video_q1",
    headerName: "Video Q1's",
    width: 150,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "video_q3",
    headerName: "Video Q3's",
    width: 150,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "video_skips",
    headerName: "Video Skips",
    width: 150,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "viewability_percent",
    headerName: "Viewability %",
    width: 160,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "viewability_measurability_percent",
    headerName: "Viewability/Measurability %",
    width: 260,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "viewable_impressions",
    headerName: "Viewable Impressions",
    width: 220,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "viewable_seconds",
    headerName: "Viewable Seconds",
    width: 200,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "viewthrough_conversions",
    headerName: "Viewthrough Conversions",
    width: 240,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
  {
    field: "vcpm",
    headerName: "vCPM",
    width: 120,
    sortComparator: percentageSortComparator,
    type: "PERCENTAGE",
    hide: true,
    sortable: true,
  },
  {
    field: "reach",
    headerName: "Reach",
    width: 120,
    sortComparator: flatSortComparator,
    type: "FLAT",
    hide: true,
    sortable: true,
  },
];

export const floatingNumbersFields = [
  "cpc_usd",
  "cpm_usd",
  "ctr",
  "spend",
  "spend_per_conversion",
  "video_companion_ctr",
  "video_complete_percent",
  "average_viewable_seconds",
  "invalid_impression_percent",
  "measurable_impression_percent",
  "vcpm",
  "viewability_percent",
  "viewability_measurability_percent",
  "conversions_value",
];
